<div class="input-text-field"
  [style.padding-top.px]="value ? 8 : 16"
  [style.padding-bottom.px]="value ? 8 : 16"
  [class.error-border]="hasError()"
  >
  @if (value) {
    <div style="text-align: start;" class="label2">{{ placeholder }}</div>
  }
  <div style="display: flex;">
    <input [type]="type"
      style="width: 100%; border: none; outline: none;"
      [style.font-weight]="value ? 400 : 600"
      class="input-text-field-font"
      [placeholder]="placeholder"
      [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)"
      />
    @if (hasError()) {
      <img ngSrc="assets/img/red-circle-alert.svg" height="16" width="16">
    }
  </div>
</div>
@if (hasError() && errorMessage) {
  <div class="caption1 error-text" style="margin-top: 8px; margin-left: 4px;" role="alert">
    {{ errorMessage }}
  </div>
}
